/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getArrayDecoder,
  getArrayEncoder,
  getBooleanDecoder,
  getBooleanEncoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

export type EmergencyAccessConfig = {
  breakGlassEnabled: boolean;
  emergencyContacts: Array<Address>;
  approvalRequired: boolean;
};

export type EmergencyAccessConfigArgs = EmergencyAccessConfig;

export function getEmergencyAccessConfigEncoder(): Encoder<EmergencyAccessConfigArgs> {
  return getStructEncoder([
    ["breakGlassEnabled", getBooleanEncoder()],
    ["emergencyContacts", getArrayEncoder(getAddressEncoder())],
    ["approvalRequired", getBooleanEncoder()],
  ]);
}

export function getEmergencyAccessConfigDecoder(): Decoder<EmergencyAccessConfig> {
  return getStructDecoder([
    ["breakGlassEnabled", getBooleanDecoder()],
    ["emergencyContacts", getArrayDecoder(getAddressDecoder())],
    ["approvalRequired", getBooleanDecoder()],
  ]);
}

export function getEmergencyAccessConfigCodec(): Codec<
  EmergencyAccessConfigArgs,
  EmergencyAccessConfig
> {
  return combineCodec(
    getEmergencyAccessConfigEncoder(),
    getEmergencyAccessConfigDecoder(),
  );
}
